import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConnectionService } from '../../services/connection-service';
import { LocalStorage } from '../../services/local-storage-service';
import { Broadcaster } from '../../components/broadcaster';
import { AppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class CouponEditorGuard implements CanActivate {

  constructor(
    private conn: ConnectionService,
    private localStorage: LocalStorage,
    private router: Router,
    private broadcaster: Broadcaster,
    private appConfig: AppConfig
  ) {}

  canActivate(): boolean {
    if (!this.conn.isUserLoggedIn) {
      this.router.navigate(['/login']);
      return false;
    }

    const userRoles: string[] = this.localStorage.getJsonValue('userRoles') || [];
    if (!userRoles.includes('couponEditor')) {
      this.broadcaster.broadcast('NOTIFY', {
        message: 'You do not have permission to access this page. CouponEditor access required.',
        type: this.appConfig.Shared.Toast.Type.ERROR,
        timeout: 5000
      });
      this.router.navigate(['/chats/open-tickets']);
      return false;
    }

    return true;
  }
}
